import React from 'react';
import '../styles/iconStyles.css';

/**
 * Get the appropriate Font Awesome icon for a timeline status code
 * @param {string} statusCode - The status code from the timeline
 * @returns {JSX.Element} Font Awesome icon component
 */
export function getTimelineIcon(statusCode) {
    // Map status codes to specific Font Awesome icons
    const iconMap = {
        'CANCL': <i className="fas fa-times-circle icon-container"></i>, // Cancelled
        'DEASSGN': <i className="fas fa-undo icon-container"></i>, // Unassigned
        'QUOTE': <i className="fas fa-dollar-sign icon-container"></i>, // Quote
        'UNAPPRVD': <i className="fas fa-ban icon-container"></i>, // Unapproved
        'ENTRY': <i className="fas fa-clipboard-list icon-container"></i>, // Entry
        'AVAIL': <i className="fas fa-bullhorn icon-container"></i>, // Available
        'ASSGN': <i className="fas fa-user-tie icon-container"></i>, // Assigned
        'PICKD': <i className="fas fa-box icon-container"></i>, // Picked up
        'DISP': <i className="fas fa-rocket icon-container"></i>, // Dispatched
        'ARRSHIP': <i className="fas fa-industry icon-container"></i>, // Arrived shipper
        'DEPSHIP': <i className="fas fa-truck icon-container"></i>, // Departed shipper
        'SPOTTED': <i className="fas fa-search icon-container"></i>, // Spotted
        'SPTLD': <i className="fas fa-box icon-container"></i>, // Spotted loaded
        'ARRCONS': <i className="fas fa-map-marker-alt icon-container"></i>, // Arrived consignee
        'DEPCONS': <i className="fas fa-sign-out-alt icon-container"></i>, // Departed consignee
        'DELVD': <i className="fas fa-check-circle icon-container"></i>, // Delivered
        'COMPLETE': <i className="fas fa-flag-checkered icon-container"></i>, // Complete
        'COMPLETED': <i className="fas fa-flag-checkered icon-container"></i>, // Completed
        'ACC': <i className="fas fa-money-bill-wave icon-container"></i>, // Accessorial
        'APPRVD': <i className="fas fa-thumbs-up icon-container"></i>, // Approved
        'BILLD': <i className="fas fa-file-invoice-dollar icon-container"></i>, // Billed
        'PRINTED': <i className="fas fa-print icon-container"></i>, // Printed
        'AUDIT': <i className="fas fa-clipboard-check icon-container"></i> // Audit
    };
    
    return iconMap[statusCode] || <i className="fas fa-thumbtack icon-container"></i>; // Default icon
}

/**
 * Get temperature-based color for thermometer icons
 * @param {number} temp - Temperature in Fahrenheit
 * @returns {string} Hex color code
 */
export function getTemperatureColor(temp) {
    if (temp < 32) return '#007bff'; // Blue for freezing
    if (temp < 50) return '#17a2b8'; // Light blue for cold
    if (temp < 80) return '#28a745'; // Green for normal
    if (temp < 90) return '#ffc107'; // Yellow for warm
    return '#dc3545'; // Red for hot
}

/**
 * Common UI icons used throughout the application
 */
export const CommonIcons = {
    truck: <i className="fas fa-truck icon-container"></i>,
    location: <i className="fas fa-map-marker-alt icon-container"></i>,
    locationPickup: <i className="fas fa-map-marker-alt icon-container"></i>,
    locationDropoff: <i className="fas fa-map-marker-alt icon-container"></i>,
    currentLocation: <i className="fas fa-location-arrow icon-container"></i>,
    temperature: <i className="fas fa-thermometer-half icon-container"></i>,
    loading: <i className="fas fa-hourglass-half icon-container"></i>,
    info: <i className="fas fa-info-circle icon-container"></i>,
    handshake: <i className="fas fa-handshake icon-container"></i>
}; 